import React from 'react';
import { TextTooltip } from '../HelpIcon';
import { emoText } from '../../shell/EmojiIcons';
import './form.css';

// THE shared config-field set (styleguide Controls): label + help-tooltip (never inline prose) + control + validation message.
// Field wraps any control; NumberField adds the unit suffix inside the field group; Toggle is the shared switch; CheckField a labelled checkbox.
export function Field({ label, help, error, children }) {
  return (
    <div className="avf-field">
      {label != null && <span className="avf-lab">{emoText(label)}{help && <TextTooltip text={help} ariaLabel={label} />}</span>}
      {children}
      {error && <span className="avf-msg" role="alert">{error}</span>}
    </div>
  );
}

export function NumberField({ label, help, unit, error, width = 120, className = '', ...input }) {
  const ctl = (
    <span className={`avf-grp${error ? ' bad' : ''}`} style={{ '--avf-w': typeof width === 'number' ? `${width}px` : width }}>
      <input type="number" inputMode="decimal" aria-label={typeof label === 'string' ? label : input['aria-label']} className={`avf-ctl ${className}`.trim()} {...input} />
      {unit && <span className="avf-unit">{unit}</span>}
    </span>
  );
  return label == null ? ctl : <Field label={label} help={help} error={error}>{ctl}</Field>;
}

export function Toggle({ checked, onChange, label, disabled = false }) {
  return <button type="button" role="switch" className="avf-sw" aria-checked={!!checked} aria-label={label} disabled={disabled} onClick={() => onChange(!checked)} />;
}

export function CheckField({ checked, onChange, label, help, disabled = false }) {
  return (
    <label className="avf-ck">
      <input type="checkbox" checked={!!checked} disabled={disabled} onChange={e => onChange(e.target.checked)} />
      {emoText(label)}{help && <TextTooltip text={help} ariaLabel={label} />}
    </label>
  );
}
